import React, { useState, useEffect } from "react";

const CountdownTimer = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const now = new Date();
    const diff = new Date(targetDate) - now;

    if (diff <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return { days, hours, minutes, seconds };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(interval); // Clean up the interval on component unmount
  }, []);

  return (
    <div className="counter_mian">
      <strong className="text">Countdown to Kick off</strong>
      <ul className="countdown">
        <li>
          <span className="countdown-number">{timeLeft.days}</span>
          <span className="countdown-label">Days</span>
        </li>
        <li>
          <span className="countdown-number">{timeLeft.hours}</span>
          <span className="countdown-label">Hours</span>
        </li>
        <li>
          <span className="countdown-number">{timeLeft.minutes}</span>
          <span className="countdown-label">Mins</span>
        </li>
        <li>
          <span className="countdown-number">{timeLeft.seconds}</span>
          <span className="countdown-label">Secs</span>
        </li>
      </ul>
    </div>
  );
};

export default CountdownTimer;
